import React, { createContext, useState, useEffect, useMemo, useCallback } from 'react';
import Cookies from 'universal-cookie';
import { login as postLogin } from '../api/Api';

const cookies = new Cookies();

export const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [userToken, setUserToken] = useState(() => {
    // Inicialización lazy - solo se ejecuta una vez
    const cookieToken = cookies.get('userToken');
    return (cookieToken && cookieToken.length > 0) ? cookieToken : '';
  });

  // NO usar useLoadingContext aquí para evitar dependencias circulares
  // El loading se manejará desde los componentes que usen estas funciones

  const logout = useCallback(async () => {
    try {
      // Primero limpiamos el estado
      setUserToken('');
      
      // Luego removemos las cookies
      cookies.remove('userToken', { path: '/' });
      cookies.remove('csrftoken', { path: '/' });
      cookies.remove('sessionid', { path: '/' });
      
      // Aseguramos que todo se complete antes de continuar
      await new Promise(resolve => setTimeout(resolve, 100));
      return { success: true };
    } catch (error) {
      console.error('Error during logout:', error);
      return { error: 'Error al cerrar sesión' };
    }
  }, []);

  const login = useCallback(async (username, password) => {
    try {
      const response = await postLogin(username, password);
      
      if (response.ok) {
        const body = await response.json();
        const userToken = body.access;
        cookies.set('userToken', userToken, { path: '/' });
        setUserToken(userToken);
        return { success: true };
      } else {
        return { error: response.statusText, status: response.status };
      }
    } catch (error) {
      console.error('Error during login:', error);
      return { error: 'Error de conexión', status: 500 };
    }
  }, []);

  // Memoizar el valor para evitar re-renders innecesarios
  const value = useMemo(() => ({
    userToken,
    login,
    logout,
  }), [userToken, login, logout]);

  // Log para debugging (quitar después)
  useEffect(() => {
    console.log('🔑 AuthContext - userToken changed:', userToken);
  }, [userToken]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
